import React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'
import AnalyticsReportsType from '~/client/src/shared/enums/AnalyticReportsType'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import AnalyticsSetupStore from '../AnalyticsSetup.store'

interface IProps {
  store: AnalyticsSetupStore
}

export default class AnalyticsSetupList extends React.Component<IProps> {
  public UNSAFE_componentWillMount(): void {
    this.props.store.updateAnalyticsSettings()
  }

  public render() {
    const {
      reportTypes,
      toggleAvailableReports,
      isAvailableReport,
      openConfigureModal,
    } = this.props.store
    return (
      <div className="col">
        <div className="row">
          <div className="parameter-value pt7">
            <div className="row mx30 mb20 bb2-brand-dark">
              <div>{Localization.translator.type}</div>
              <div className="mw120 row text large x-center">
                <div>{Localization.translator.showInReports}</div>
              </div>
              <div className="row mw160 large x-center">Configure</div>
            </div>
            {reportTypes.map(type => (
              <div key={type.id} className="row mx30 mb10 pb10 bb-light-grey">
                <div className="row">
                  <span className="text extra-large bold w-fit-content ml5">
                    {type.name}
                  </span>
                </div>
                <div className="mw120 tw:flex tw:justify-center">
                  <Switch
                    checked={isAvailableReport(type.id)}
                    onCheckedChange={toggleAvailableReports.bind(null, type.id)}
                  />
                </div>
                <div className="mw160">
                  {type.type === AnalyticsReportsType.FORM_REPORT && (
                    <Button
                      variant="outline"
                      onClick={openConfigureModal.bind(null, type)}
                    >
                      {Localization.translator.configureColumns}
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}
